// Match the scheduler's commission rounding without changing stored prices.
export function getBoostPricingComparison(request, standardCost, now = Date.now()) {
  if (!request || request.status === "CANCELED" || !standardCost) return null
  // Older shifts have no flag, so only an explicit false switches the boost off.
  if (request.lastMinuteBoostEnabled === false) return null
  const fields = ["totalCost", "companyCommission", "employeeEarnings"]
  if (!fields.every(key => Number.isSafeInteger(standardCost[key]) && standardCost[key] >= 0 && Number.isSafeInteger(request.cost?.[key]) && request.cost[key] >= 0)) return null
  const commission = Math.round(standardCost.companyCommission * 0.5)
  const boosted = {...standardCost, companyCommission: commission, employeeEarnings: standardCost.totalCost - commission}
  if (boosted.employeeEarnings < 0 || commission === standardCost.companyCommission) return null

  if (request.isLastMinute) {
    // A changed configuration must not produce a misleading historical comparison.
    if (!fields.every(key => request.cost?.[key] === boosted[key])) return null
    return {standard: standardCost, boosted: request.cost, applied: true}
  }

  const timestamp = value => value?.valueOf ? Number(value.valueOf()) : NaN
  const start = timestamp(request.mStartDate)
  const deadline = timestamp(request.mDeadline)
  if (request.status !== "VERIFIED" || request.claimedBy != null ||
      !Number.isFinite(start) || !Number.isFinite(deadline) ||
      start <= now || start - now > 24 * 60 * 60 * 1000 || deadline <= now) return null
  return {standard: request.cost, boosted, applied: false}
}
